import { useIsViewingAsToCompany } from './useIsViewingAsToCompany'

export function useIsViewingAsFromCompany() {
  return !useIsViewingAsToCompany()
}
